import React from "react";
import Box from "components/common/Box";
import Text from "components/common/Text";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "components/common/IconButton";
import { Button, InputBase } from "@mui/material";
import TitleBox from "../../components/common/TitleBox";
import Stack from "components/common/Stack";
import Grid from "@mui/material/Grid";
import Link from "components/common/Link";
import Paper from "@mui/material/Paper";
import Vendor from "components/Admin/Vender";
import EnableDesableVendor from "components/Admin/EnableDesableVendor";
import { VendorApi } from "stores/VendorStore/vendoApi";

export default class VendorContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      inputText: "",
      VendorConfirmDaialog: false,
      AddVendorStatus: "",
      AddVendorStatusId: "",
      stationId_from_vendor: "",
      SelectedVendor: "all2",
    };
  }

  async componentDidMount() {
    if (this.props.history?.location?.state?.vendorId) {
      await this.props.getAdminTableAction(
        this.props.history?.location?.state?.vendorId
      );
    } else {
      await this.props.getAdminTableAction();
    }

    this.props.getVendorCityAction();
    this.props.getVendorCountAction();
  }

  inputSearchHandler = (e) => {
    if (this.state.SelectedVendor !== "all2") {
      this.setState({ SelectedVendor: "all2" });
      this.props.getAdminTableAction();
    }

    var lowerCase = e.toLowerCase();

    this.setState({ inputText: lowerCase });
  };

  handleOnchangeSelectCity(value) {
    this.setState({ SelectedVendor: value });
    if (value === "all2") {
      this.props.getAdminTableAction();
    } else {
      this.props.getAdminTableAction(value);
    }
  }

  handleVendorClose = () => {
    this.setState({ VendorConfirmDaialog: false });
  };

  handleStatusEnableVendor = (id, status) => {
    this.setState({
      VendorConfirmDaialog: true,
      AddVendorStatus: status,
      AddVendorStatusId: id,
    });
  };

  handleEnableClickVendor = async () => {
    const status = this.state.AddVendorStatus;
    const id = this.state.AddVendorStatusId;

    if (status === 1) {
      await VendorApi.postVendorListApi({ id, status: 0 });
      this.setState({ AddVendorStatus: 0 });
      this.props.getAdminTableAction();
    } else {
      await VendorApi.postVendorListApi({ id, status: 1 });
      this.props.getAdminTableAction();
    }

    this.setState({ VendorConfirmDaialog: false });
  };

  render() {
    const VendorListisLoading = this.props.VendorListisLoading;
    const citylist = this.props?.VendorCityList?.result;

    const count = this.props?.VendorCountList?.result;

    const TotalCount =
      count?.approved_vendors + count?.pending_vendors
        ? count?.approved_vendors + count?.pending_vendors
        : "";

    const data = this.props?.AdminTableList?.result?.vendors;

    const TitleBoxData = [
      { title: "Total Vendors", number: TotalCount },
      { title: "Approve Vendors", number: count?.approved_vendors },
      { title: "Pending Requests", number: count?.pending_vendors },
    ];
    const chargingStationCity = this.props.history?.location?.state?.vendorId;

    var tempSelectedCity = chargingStationCity
      ? chargingStationCity
      : this.state.SelectedVendor;

    const filteredData = data?.filter((el) => {
      if (this.state.inputText === "") {
        if (tempSelectedCity === "all2") {
          return el;
        }
        return el.charging_station !== 0;
      } else {
        return (
          el.vendors_name?.toLowerCase().includes(this.state.inputText) &&
          el.charging_station !== 0
        );
      }
    });

    return (
      <>
        <Stack sx={{ marginTop: "1.6rem" }}>
          <Paper sx={{ p: 3, mt: 1 }}>
            <Grid
              container
              direction={{ sm: "column", xs: "column", md: "row" }}
            >
              <Grid item xs={8}>
                <Text
                  variant="h5"
                  color="#707070"
                  sx={{
                    fontSize: "24px",
                    fontWeight: "600",
                    marginBottom: "40px",
                    marginLeft: "15px",
                    marginTop: "20px",
                  }}
                >
                  Vendors
                </Text>
              </Grid>
              <Grid item xs={1}></Grid>
              <Grid
                item
                xs={3}
                sx={{
                  marginTop: "1rem",
                  display: "flex",
                  border: "1px solid grey",
                  borderRadius: "5px",
                  width: "10rem",
                  height: "2.5rem",
                  backgroundColor: "#ffffff",
                }}
              >
                <IconButton
                  type="submit"
                  sx={{ display: "flex", marginLeft: "6px" }}
                  aria-label="search"
                >
                  <SearchIcon />
                </IconButton>
                <InputBase
                  sx={{ color: "black", marginTop: "4px", marginLeft: "3px" }}
                  placeholder="Search"
                  onChange={(e) => this.inputSearchHandler(e.target.value)}
                  inputProps={{ "aria-label": "search" }}
                />
              </Grid>
            </Grid>

            <Grid
              container
              direction={{ sm: "column", xs: "column", md: "row" }}
              style={{
                background: "#EFF5FF",
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "2rem",
                marginTop: "10px",
              }}
            >
              <Grid item xs={4}>
                <Text
                  sx={{
                    width: "157px",
                    height: "27px",
                    fontStyle: "normal",
                    fontWeight: "400",
                    fontSize: "20px",
                    lineHeight: "27px",
                    color: "#252C32",
                    marginLeft: "20px",
                    marginTop: "15px",
                  }}
                >
                  Vendor Requests
                </Text>
              </Grid>
              <Grid p={2}>
                <Button sx={{ marginRight: "20px", background: "#DAE8FF" }}>
                  <Link
                    style={{
                      textDecoration: "none",
                    }}
                    to="/vendor/request"
                  >
                    <Text
                      sx={{
                        width: "120px",
                        height: "25px",
                        fontStyle: "normal",
                        fontWeight: "400",
                        fontSize: "12px",
                        lineHeight: "22px",
                        color: "#2B70C5",
                      }}
                    >
                      See all requests
                    </Text>
                  </Link>
                </Button>
              </Grid>
            </Grid>

            <Grid item>
              <Stack spacing={1}>
                <Stack
                  sx={{ marginBottom: "2rem", justifyContent: "space-between" }}
                  spacing={2}
                  direction={{ sm: "column", xs: "column", md: "row" }}
                >
                  {TitleBoxData?.map((prop, index) => (
                    <Box key={index} sx={{ display: "flex" }}>
                      <TitleBox data={prop} />
                    </Box>
                  ))}
                </Stack>
              </Stack>
            </Grid>
            <Vendor
              selectCityDefaultValue={
                this.props.history?.location?.state?.vendorId
              }
              VendorListisLoading={VendorListisLoading}
              citylist={citylist}
              data={filteredData}
              stationId_from_vendor={this.state.stationId_from_vendor}
              handleOnchangeSelectCity={(val) =>
                this.handleOnchangeSelectCity(val)
              }
              handleStatusEnableVendor={this.handleStatusEnableVendor}
              SelectedVendor={this.state.SelectedVendor}
            />
            <EnableDesableVendor
              open={this.state.VendorConfirmDaialog}
              handleEnable={this.handleEnableClickVendor}
              handleclose={this.handleVendorClose}
              AddVendorStatus={this.state.AddVendorStatus}
            />
          </Paper>
        </Stack>
      </>
    );
  }
}
